// import globalStore from '@/services/global.state';
// import i18n from '@/i18n';
import {Linking} from 'react-native';
import {goCS, goTo} from '@/utils';
import {
  apiSendPhoneCode,
  defaultPhoneCode,
  packageId,
  homePage,
} from '@/config';

export function toAgentApply(tabKey: string = 'agent') {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const isLoggedIn = user && user.userId;
    const isAgent = user?.isAgent === 1;

    // 未登录
    if (!isLoggedIn) {
      if (tabKey === 'agent') {
        // agent 标签：直接跳转AgentPage
        goTo('AgentPage');
      } else {
        // 其他标签：直接跳转到对应标签
        goTo(homePage, {screen: 'EarnMoney', params: {tabKey}});
      }
      return;
    }

    // 已登录非代理
    if (!isAgent) {
      if (tabKey === 'agent') {
        // agent 标签：跳转AgentPage
        goTo('AgentPage');
      } else {
        // 其他标签：跳转到对应标签
        goTo(homePage, {screen: 'EarnMoney', params: {tabKey}});
      }
      return;
    }

    // 已登录是代理：跳转到对应标签
    goTo(homePage, {screen: 'EarnMoney', params: {tabKey}});
  } catch (error) {
    // 读取失败或解析失败，按未登录处理
    if (tabKey === 'agent') {
      goTo('AgentPage');
    } else {
      goTo(homePage, {screen: 'EarnMoney', params: {tabKey}});
    }
  }
}

export const goAgentService = () => {
  const linkMap: Record<number, string> = {
    3: 'https://nimble.li/v9a88qqd',
  };
  const whatsAppLink = linkMap[packageId];
  if (whatsAppLink) {
    Linking.openURL(whatsAppLink);
  } else {
    goCS();
  }
};

export function goWhatsAppChat(userPhone?: string, message?: string) {
  if (!userPhone) {
    return;
  }
  Linking.openURL(
    `https://wa.me/${(apiSendPhoneCode ? '' : defaultPhoneCode) + userPhone}${
      message ? `?text=${encodeURIComponent(message)}` : ''
    }`,
  );
}
